export const ERROR_MESSAGES = {
  REQUIRED: "This field is required",
  EMAIL: "This field must be a valid email address",
  MIN_LENGTH: n => `This field must be at least ${n} characters long`,
  MAX_LENGTH: n => `This field must not exceed ${n} characters`,
};
